// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderMessage_wrapper__JYcaF","title":"OrderMessage_title__UU6h1"};